export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-fr-01dd67f73a6c2e87650aef57435541e8.png";